import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Send } from "lucide-react";
import BrandMark from "@/components/BrandMark";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");
    try {
      const response = await api.post("/auth/forgot-password", { email: email.trim() });
      setMessage(response.data?.message || "Jika email terdaftar, tautan reset password akan dikirim.");
    } catch (requestError) {
      setError(requestError?.response?.data?.detail || "Permintaan belum dapat diproses. Silakan coba kembali.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(34,211,238,.18),transparent_30%),radial-gradient(circle_at_80%_80%,rgba(99,102,241,.22),transparent_34%)]" />
      <div className="relative mx-auto flex min-h-screen max-w-7xl items-center justify-center p-5 sm:p-8">
        <div className="w-full max-w-md rounded-[2rem] border border-white/10 bg-white p-6 text-slate-950 shadow-2xl shadow-black/30 sm:p-9">
          <div className="flex items-center justify-between">
            <Link to="/"><BrandMark accentClassName="text-blue-600" /></Link>
            <Link to="/login" className="inline-flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-slate-950"><ArrowLeft className="h-3.5 w-3.5" /> Kembali login</Link>
          </div>
          <div className="mt-8 flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"><Mail className="h-6 w-6" /></div>
          <h1 className="mt-5 font-display text-4xl font-black tracking-[-0.05em]">Lupa password?</h1>
          <p className="mt-2 text-sm leading-6 text-slate-500">Masukkan email akun KRAYA. Tautan reset akan berlaku selama 30 menit.</p>

          {message && <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm leading-6 text-emerald-800">{message}</div>}
          {error && <div className="mt-6 rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm leading-6 text-rose-800">{error}</div>}

          <form onSubmit={submit} className="mt-7 space-y-5">
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">Alamat email</label>
              <input type="email" required autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-sm outline-none transition focus:border-blue-500 focus:bg-white focus:ring-4 focus:ring-blue-100" placeholder="nama@bisnis.com" />
            </div>
            <button type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 py-3.5 text-sm font-bold text-white transition hover:bg-blue-600 disabled:opacity-50">
              <Send className="h-4 w-4" /> {loading ? "Mengirim…" : "Kirim Link Reset"}
            </button>
          </form>
          <div className="mt-7 border-t border-slate-200 pt-6 text-center text-sm text-slate-500">Sudah ingat password? <Link to="/login" className="font-bold text-blue-600">Masuk</Link></div>
          <div className="mt-6 text-center text-[11px] uppercase tracking-[0.16em] text-slate-400">Powered By AntSoft ID</div>
        </div>
      </div>
    </div>
  );
}
